import { parseUnits, } from "viem";
import { getTokenDefinition, } from "./getTokenDefinition";

import type {
	TokenName,
	TokenAddress,
	TokenDefinition,
} from "@bracket/chainography/types";



/**
 * Converts a number, string, or bigint amount to a bigint representation in WEI
 * @param {number|string|bigint} amount - The amount to convert
 * @param {TokenName|TokenAddress|TokenDefinition} [type] - Optional token type to determine decimals
 * @returns {bigint} The amount converted to WEI as a bigint
 * @throws {Error} If the amount is not a valid number or if conversion fails
 */
export const bigintize = ( amount:number|string|bigint, type?: TokenName|TokenAddress|TokenDefinition, ): bigint => {
	try {

		const token = type ? getTokenDefinition(type) : { decimals: 18 };
		if(!token.decimals) {
			token.decimals = token.decimals < 6 ? 18 : token.decimals
		}
		// if its a bigint, we assume this is already in wei
		if(typeof amount === "bigint") return amount;
		if(typeof amount === "string") {
			if(/^[0-9.]+$/.test(amount)) {
				return parseUnits(amount, token.decimals);
			}
			throw new Error(`argued value string "${amount}" is not a numeric`);
		}
		if(typeof amount === "number") {
			return parseUnits(amount.toString(), token.decimals);
		}
		throw new Error("argued an unacceptable type for the amount - expected number, string or bigint");
	}
	catch(err) {
		throw new Error(`@bracket/chainography::bigintize - failed to produce a bigint - ${err.message}`);
	}
}
